var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dast-promo-feature"},[(_vm.icon)?_c('div',{staticClass:"dast-promo-feature-icon"},[_c(_vm.icon,{tag:"component",attrs:{"fill":'white'}})],1):_vm._e(),_c('div',{staticClass:"dast-promo-feature-text"},[_vm._v(_vm._s(_vm.text))])])
}
var staticRenderFns = []

export { render, staticRenderFns }